import { Box, styled, TableCell } from '@mui/material';
import { StyledCheckbox } from '../../Checkbox';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';

export const TableCellStyledForInstallment = styled(TableCell)(({ theme }) => ({
  color: 'white',
  padding: '1rem 3rem',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
  whiteSpace: 'nowrap',
}));

export const TableCellGroupForInstallment = styled(TableCellStyledForInstallment)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const StyledCheckboxTerms = styled(StyledCheckbox)(({ theme }) => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
  padding: '0px',
  marginRight: '1.25rem',
  '&.Mui-disabled': {
    cursor: 'not-allowed',
  },
  '&.Mui-disabled .MuiSvgIcon-root': {
    color: theme.palette.secondary.main,
  },
  '&.Mui-disabled .MuiFormControlLabel-label': {
    color: theme.palette.text.disabled,
  },
}));

export const TableFooterBoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: '1rem',
  minHeight: '3.125rem',
  backgroundColor: theme.palette.primary.dark,
}));

export const Footer = styled(BodySmallRegular)(({ theme }) => ({
  color: theme.palette.common.white,
  paddingRight: '4rem',
}));